import React, { useRef, useState, useEffect } from 'react';
import * as cl from './Peak.module.scss';
import { Preloader } from '../../components/Preloader';

const Peak = () => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }

    const onIframeMessage = (event) => {
      if (event?.data?.type !== 'documentHeight') {
        return;
      }

      iframeRef.current.style.height = event.data.height + 'px';

      if (iframeRef.current.style.visibility !== 'visible') {
        iframeRef.current.style.visibility = 'visible';
        setIsLoading(false);
      }
    };

    window.addEventListener('message', onIframeMessage);

    return () => {
      window.addEventListener('message', onIframeMessage);
    };
  }, [iframeRef.current]);

  return (
    <div>
      {isLoading && <Preloader className={cl.preloader} />}
      <iframe
        ref={iframeRef}
        title='Peak'
        src='https://peak-qa.pokercoaching.com/view?_pc_webview'
        className={cl.iframe}
      />
    </div>
  );
};
export default Peak;
